import moment from "moment";

const formatTime = (isoString) =>
  isoString ? moment(isoString).format("YYYY-MM-DD HH:mm:ss") : "";

export const convertDeviceProductionToCSV = (responseData) => {
  if (!responseData)
    throw new Error("Device production data is null or undefined");
  const dataArray = responseData.data || responseData;
  if (!Array.isArray(dataArray))
    throw new Error("Expected data to be an array");

  const rows = [];

  // Header group row
  rows.push([
    "Device Production",
    "",
    "",
    "",
    "Device Details",
    "",
    "",
    "",
    "",
    "",
    "",
    "",
  ]);

  // Column header row
  rows.push([
    "No",
    "Name",
    "Description",
    "Production Time",
    "Device No",
    "Device Name",
    "OEM",
    "Dealer",
    "Customer",
    "Node Type",
    "Site Type",
    "MAC",
    "Product",
    "Model",
    "Type",
  ]);

  dataArray.forEach((production) => {
    const devices = production.DeviceProdsItems || [];

    if (devices.length === 0) {
      rows.push([
        production.ProductionNo || "",
        production.ProductionName || "",
        production.ProductionDesc || "",
        formatTime(production.ProductionTime),
        "No devices",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
        "",
      ]);
      return;
    }

    devices.forEach((device) => {
      rows.push([
        production.ProductionNo || "",
        production.ProductionName || "",
        production.ProductionDesc || "",
        formatTime(production.ProductionTime),
        device.DeviceNo || "",
        device.DeviceName || "",
        device.OemNo || "",
        device.DealerNo || "",
        device.CustomerNo || "",
        device.NodeType || "",
        device.SiteType || "",
        device.Mac || "",
        device.Product || "",
        device.Model || "",
        device.Type || "",
      ]);
    });
  });

  const csvContent = rows
    .map((row) =>
      row
        .map((cell) => {
          const cellStr = String(cell ?? "");
          if (
            cellStr.includes(",") ||
            cellStr.includes('"') ||
            cellStr.includes("\n")
          ) {
            return `"${cellStr.replace(/"/g, '""')}"`;
          }
          return cellStr;
        })
        .join(",")
    )
    .join("\n");

  return csvContent;
};

export const downloadDeviceProductionCSV = (
  productionData,
  filename = "device_production_report.csv"
) => {
  const csvContent = convertDeviceProductionToCSV(productionData);
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const link = document.createElement("a");
  const url = URL.createObjectURL(blob);
  link.setAttribute("href", url);
  link.setAttribute("download", filename);
  link.style.visibility = "hidden";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
